module.exports = __webpack_public_path__ + "img/club-loyalty-2.1f6d1bcb.svg";